var _path, _path2, _path3, _path4, _path5, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZipIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ZIP_ICON",
    "data-name": "ZIP ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_509385",
    "data-name": "Path 509385",
    d: "M111.857,59.992c.093-1.32.143-2.652.143-4a56,56,0,1,0-70.917,53.985Z",
    fill: "#fdcc77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_509386",
    "data-name": "Path 509386",
    d: "M205.166,121,162.081,77.913,119.1,156.068l15.078,15.078A56.21,56.21,0,0,0,205.166,121Z",
    transform: "translate(-93.31 -61.164)",
    fill: "#fcb433"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_509387",
    "data-name": "Path 509387",
    d: "M154.036,134.087l-4.963-56.174H119.1V129.2Z",
    transform: "translate(-93.08 -60.922)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_509388",
    "data-name": "Path 509388",
    d: "M285.815,129.2V95.009L273.6,90.125l-4.885-12.212H255.711l.078,56.174Z",
    transform: "translate(-199.838 -60.922)",
    fill: "#e8e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_509389",
    "data-name": "Path 509389",
    d: "M314.991,95.009v-17.1l17.1,17.1Z",
    transform: "translate(-246.125 -60.879)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72287",
    "data-name": "Rectangle 72287",
    width: 59.734,
    height: 26.866,
    transform: "translate(26.133 68.107)",
    fill: "#9e7120"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_272794",
    "data-name": "Group 272794",
    transform: "translate(42.157 75.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509390",
    "data-name": "Path 509390",
    d: "M196.867,355.67h6.311v2.341H192.915v-1.893l6.227-7.39h-6.011v-2.341h9.947v1.893Z",
    transform: "translate(-192.915 -346.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509391",
    "data-name": "Path 509391",
    d: "M249.075,358.011V346.387h2.956v11.624Z",
    transform: "translate(-236.752 -346.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509392",
    "data-name": "Path 509392",
    d: "M280.1,346.387c2.972,0,4.683,1.461,4.683,4.052,0,2.724-1.711,4.3-4.683,4.3h-2.109v3.271h-2.956V346.387Zm-2.109,6.028h1.96c1.3,0,2.042-.648,2.042-1.877,0-1.212-.747-1.827-2.042-1.827h-1.96Z",
    transform: "translate(-257.016 -346.387)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipIcon);
export default __webpack_public_path__ + "static/media/ZipIcon.65804dcf32334473b798b9675a3353b6.svg";
export { ForwardRef as ReactComponent };